














import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Report from "../../models/report/Report";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import ReportUpdateDialogDateAndTime from "@/components/report/ReportUpdateDialogDateAndTime.vue";
import ReportSimple from "@/models/report/ReportSimple";
import {Permissions, ReportState} from "@/helpers/constants";

@Component({
	components: {ReportUpdateDialogDateAndTime, AsiCardDetailEntry, AsiCardDetail}
})
export default class ReportCardDateAndTime extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get canBeEdited(): boolean {
		if (this.report === null) return false;
		if (this.report.state === ReportState.created) {
			return this.isDriverOfReport || this.isOffice;
		} else if (this.report.state !== ReportState.locked) {
			return this.isCheckReports || this.isBilling;
		} else {
			return false;
		}
	}

	private get isDriverOfReport(): boolean {
		if (this.report === null) return false;
		return this.report.user.id === this.$store.getters['user/userId'];
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get missionHourLines(): string[] | null {
		if (this.report === null) return null;
		return ReportSimple.missionHourLines(this.report);
	}

	private get breakDuration(): string | null {
		if (this.report === null) return null;
		return ReportSimple.breakDuration(this.report);
	}

	private get workingHours(): string | null {
		if (this.report === null) return null;
		return ReportSimple.workingHours(this.report);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
